

/**
 * @ngdoc function
 * @name app.controller:ModalKjsonCtrl
 * @description
 * # ModalKjsonCtrl
 * Controller of the app
 */
angular.module('app')
	.controller('ModalKjsonCtrl', /* @ngInject */ function ($scope, $uibModalInstance, kjson) {
		$scope.obj = {
			data:    kjson,
			options: {
				modes: [
					'tree',
					'view',
					'form',
					'code',
					'text',
				],
			},
		};

		$scope.cancel = () => {
			$uibModalInstance.dismiss('cancel');
		};

		$scope.save = () => {
			$uibModalInstance.close({ kjson: $scope.obj.data });
		};

		$scope.onLoaded = editor => {
			editor.modes = [
				'tree',
				'view',
				'form',
				'code',
				'text',
			];
		};
	});
